export const growth = {
  SN: 1_957_606_941_104,
  KI: 1_486_533_876_373,
};

export const publicSectorShare = 0.49;

const costs = {
  Förskoleplats: 187_153,
  Grundskoleelev: 140_879,
  Gymnasieelev: 146_021,
  Lärare: 482_400,
  Polis: 529_200,
  Läkarbesök: 2_705,
  Äldreboendeplats: 911_716,
  Fängelseplats: 1_416_138,
  Gripenplan: 2_289_806_303,
  Motorvägsmil: 636_404_849,
  'Nya Karolinska': 24_270_495_349,
  'Höghastighetståg km': 689_479_458,
};

export const items = Object.keys(costs);

const units = {
  Förskoleplats: 'förskoleplatser',
  Grundskoleelev: 'grundskoleplatser',
  Gymnasieelev: 'gymnasieplatser',
  Lärare: 'lärares löner',
  Polis: 'polisers löner',
  Läkarbesök: 'läkarbesök i primärvården',
  Äldreboendeplats: 'äldreboendeplatser',
  Fängelseplats: 'fängelseplatser',
  Gripenplan: 'JAS Gripen',
  Motorvägsmil: 'mil motorväg',
  'Nya Karolinska': 'gånger byggkostnaden för Nya Karolinska',
  'Höghastighetståg km': 'kilometer höghastighetsbana',
};

export const getEquivalents = item => {
  if (!costs[item]) return undefined;

  return {
    SN: (growth.SN * publicSectorShare) / costs[item],
    KI: (growth.KI * publicSectorShare) / costs[item],
    delta: ((growth.SN - growth.KI) * publicSectorShare) / costs[item],
    unit: units[item],
  };
};
